import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, useTheme, useMediaQuery, } from '@mui/material';
import Machines from '@components/machines/Machines';
const Dashboard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    return (_jsxs(Box, { children: [_jsx(Box, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    mb: { xs: 2, md: 3 },
                    flexDirection: { xs: 'column', sm: 'row' },
                    textAlign: { xs: 'center', sm: 'left' },
                }, children: _jsx("img", { src: "/tractor.png", alt: "Tractor", style: {
                        width: isMobile ? '60px' : '80px',
                        height: 'auto',
                        marginRight: isMobile ? '0' : '16px',
                        marginBottom: isMobile ? '8px' : '0'
                    } }) }), _jsx(Machines, { hideTitle: false })] }));
};
export default Dashboard;
